exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2kCErCljjgWP3lAykX7KTB {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 100%;\n  overflow-x: hidden;\n  height: 100%;\n}\n._2kCErCljjgWP3lAykX7KTB ._2E0uyVucyfq0y5tp3QPXti {\n  display: flex;\n  flex: 1;\n  background-color: #fff;\n  padding: 0;\n  overflow: hidden;\n}\n._2kCErCljjgWP3lAykX7KTB ._2E0uyVucyfq0y5tp3QPXti ._2pAy8GG7mcC7DWFM7b0Zgg {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n}\n", ""]);
// Exports
exports.locals = {
	"page": "_2kCErCljjgWP3lAykX7KTB",
	"content": "_2E0uyVucyfq0y5tp3QPXti",
	"pane": "_2pAy8GG7mcC7DWFM7b0Zgg"
};